<template>
    <div class="page-events">
        <div class="container">
            <div class="inner">
                <h1 class="title title--h1 title--separator">
                    {{ $t('auth.eventsPage.title') }}
                </h1>

                <div v-if="eventStore.events && eventStore.events.length > 6" class="filter-orga">
                    <FormKit
                        type="text"
                        name="filter"
                        v-model="filterText"
                        :placeholder="$t('auth.eventsPage.filterPlaceHolder')"
                    />
                </div>
                <div v-if="currentEvents.length" class="list-events">
                    <CardEvent
                        :sellingSession="getSellingSession(event._id)"
                        @clicked="eventClicked"
                        :event="event" v-for="event in currentEvents" :key="event._id" />
                </div>
                <div v-else class="empty-events">
                    <h2 class="title-h2">
                        Aucun résultat 😢
                    </h2>
                </div>

                <div v-if="pastEvents.length" class="toggle-past-events">
                    <FormKit
                        type="checkbox"
                        name="showPastEvents"
                        v-model="showPastEvents"
                        label="Afficher les événements passés"
                    />
                </div>

                <div v-if="showPastEvents && pastEvents.length" class="list-events list-events--past">
                    <CardEvent
                        :sellingSession="getSellingSession(event._id)"
                        @clicked="eventClicked"
                        :event="event" v-for="event in pastEvents" :key="event._id" />
                </div>

                <div v-if="userStore.organisations.length > 1" class="back">
                    <Button :fullWidth="false"  @click="goToOrganisations()">
                        Retour aux organisations
                    </Button>
                </div>


            </div>
            <SessionLogoutVue :logout="true" />
        </div>
    </div>
</template>

<script setup lang="ts">
    import { computed, onMounted, ref } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useEventStore } from '@/stores/EventStore';
import CardEvent from '@/components/molecules/CardEvent.vue';
import { Event } from '@/interfaces/Event';
import { useUserStore } from '@/stores/UserStore';
import { toast } from 'vue3-toastify';
import shoetest from 'shoetest';
import SessionLogoutVue from '@/components/atoms/SessionLogout.vue';
import { SellingSession } from '@/interfaces/SellingSession';
import { useAppStore } from '@/stores/AppStore';
import Button from '@/components/atoms/Button.vue';

    const appStore = useAppStore()
    const eventStore = useEventStore()
    const route = useRoute()
    const router = useRouter()
    const userStore = useUserStore()
    const filterText = ref(null)
    const showPastEvents = ref(false)

    onMounted(async () => {
        const id = String(route.params.organisationId)
        await eventStore.listAllEvents(id)
    })

    const eventClicked = async (event: Event, sellingSession: SellingSession) => {
        if (sellingSession) {
            resumeSellingSession(event, sellingSession)
        }
        else {
            selectEvent(event)
        }
    }

    const resumeSellingSession = async (event: Event, sellingSession: SellingSession) => {
        userStore.sessionStarted = true
        userStore.sellingSession = sellingSession
        const eventId = sellingSession.eventId._id
        if (eventId == event._id) {
            await eventStore.retrieveEvent(eventId)
            router.push({name: 'ticket', params: { eventId: event._id}});
        }
    }

    const goToOrganisations = () => {
        userStore.organisation = null
        router.push({name: 'organisations'})
    }

    const selectEvent = async (event: Event) => {
        try {
            eventStore.currentEvent = event
            await userStore.createSellingSession(event)
            if (event.dates.type == 'sessions') {
                router.push({name: 'event_sessions', params: { eventId: event._id}});            }
            else {
                router.push({name: 'ticket', params: { eventId: event._id}});
            }
        } catch (error) {
            toast.error('Impossible de créer une session de vente')
        }
    }

    const getSellingSession = (eventId: string) => {
        if (userStore.sellingSessions) {
            return userStore.sellingSessions.find(sellingSession => sellingSession.eventId._id === eventId)
        }
        return null
    }

    const filteredEvents = computed(() => {
        if (!eventStore.events) {
            return []
        }

        const organisationId = String(route.params.organisationId)

        return eventStore.events?.filter((el: Event) => {
            if (el.organisationId._id !== organisationId) {
                return false
            }
            if (!filterText.value) {
                return true
            }
            return shoetest.test(filterText.value.trim(), el.name)
        })
    })

    const currentEvents = computed(() => {
        return filteredEvents.value.filter((event: Event) => {
            return event.status === 'published' || event.status === 'draft'
        })
    })

    const pastEvents = computed(() => {
        return filteredEvents.value.filter((event: Event) => {
            return event.status === 'passed' || event.status === 'closed'
        })
    })

</script>